// @flow
import { execute } from 'fg-frontend/src/partialUpdate/partialUpdate';
import closeEsp from 'fg-frontend/webActions/closeEsp';
import goBack from 'fg-frontend/webActions/goBack';
import scrollToHref from 'fg-frontend/webActions/scrollToHref';
import passwordStrength from 'fg-frontend/webActions/passwordStrength';
import toggleClass from 'fg-frontend/webActions/toggleClass';
import executeAndClose from 'fg-frontend/webActions/executeAndClose';

import confirmPopup from './webActions/confirmPopup';
import openFulltext from './webActions/openFulltext';
import autoClick from './webActions/autoClick';
import autoSelect from './webActions/autoSelect';
import checkAll from './webActions/checkAll';
import replaceWhiteSpace from './webActions/replaceWhiteSpace';
import confirmPopupMessage from './webActions/confirmPopupMessage';
import confirmPopupSubmitCheckboxes from './webActions/confirmPopupSubmitCheckboxes';

export default (action) => {
	switch (action) {
		case 'execute':
			return execute;
		case 'closeEsp':
			return closeEsp;
		case 'executeAndClose':
			return (payload) => {
				if (payload && payload.reload) {
					window.edeeshopPopup.close();
					window.location.reload();
				} else {
					executeAndClose(payload);
				}
			};
		case 'goBack':
			return goBack;
		case 'scrollToHref':
			return scrollToHref;
		case 'passwordStrength':
			return passwordStrength;
		case 'confirmPopup':
			return confirmPopup;
		case 'confirmPopupMessage':
			return confirmPopupMessage;
		case 'confirmPopupSubmitCheckboxes':
			return confirmPopupSubmitCheckboxes;
		case 'toggleClass':
			return toggleClass;
		case 'openFulltext':
			return openFulltext;
		case 'autoClick':
			return autoClick;
		case 'autoSelect':
			return autoSelect;
		case 'checkAll':
			return checkAll;
		case 'replaceWhiteSpace':
			return replaceWhiteSpace;
		default:
			console.log(`Unknown action`);
			return null;
	}
};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/configureWebActions.js